/**
 * Schedule Month Component
 *
 * Renders a month section in the schedule view.
 * Shows a sticky month header with navigation and a list of day rows.
 *
 * @element peach-schedule-month
 */

import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { ScheduleMonth } from "../services/calendar-data";
import "./schedule-day";

@customElement("peach-schedule-month")
export class ScheduleMonthComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: Object })
  declare month: ScheduleMonth;

  @property({ type: Object })
  declare searchPoint: { lat: number; lng: number } | null;

  constructor() {
    super();
    this.month = null as unknown as ScheduleMonth;
    this.searchPoint = null;
  }

  render() {
    if (!this.month) return null;

    return html`
      <section class="mb-0">
        <div class="sticky top-0 z-20 bg-brand px-4 py-3">
          <h2 class="text-2xl font-bold text-white font-heading tracking-wide uppercase text-center">
            ${this.month.label}
          </h2>
        </div>

        <div>
          ${this.month.days.map(
            (day) => html`
              <peach-schedule-day
                .day=${day}
                .searchPoint=${this.searchPoint}
              ></peach-schedule-day>
            `
          )}
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "peach-schedule-month": ScheduleMonthComponent;
  }
}
